import { ReactElement, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// types
import { useAuthenticated } from '../../auth/AuthContext';

// ==============================|| AUTH GUARD ||============================== //
export type GuardProps = {
  children: ReactElement | null;
};

export default function AuthGuard({ children }: GuardProps) {
  const { isAuthenticated } = useAuthenticated();
  const navigate = useNavigate();

  console.log('isLoggedIn', isAuthenticated);

  useEffect(() => {
    const loggedIn = localStorage.getItem('isAuthenticated');

    console.log(loggedIn);
    if (!loggedIn) {
      console.log('im working');
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return children;
}
